import styled from "styled-components";
import { palette } from "styled-theme";

const FormActionsWrapper = styled.div`
  margin-top: 0;
  padding-top: 10px;
  padding-bottom: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
  .ant-form-item {
    margin: 0;
  }
  &.modalActions {
    .ant-form-item-control {
      max-width: 100%;
      .ant-form-item-control-input-content {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
`;

export default FormActionsWrapper;
